import MoveLogoShort from './MoveLogoShort.png'
import './moveTeamImg.css'

const moveTeamImg= <img className='panel-moveLogo' src={MoveLogoShort}/>;

export default moveTeamImg;